/* Service worker registration — Anderson College PWA Phase 0
 *
 * - Registers /service-worker.js once the page has fully loaded so we don't
 *   compete with critical-path resources.
 * - Skips registration on localhost ONLY (so HMR / yarn start on a dev box
 *   isn't disrupted). Every deployed environment — including the staging
 *   preview — registers the SW so the install banner is testable on real
 *   devices.
 * - Auto-promotes a new SW once it finishes installing (skipWaiting +
 *   reload) so users get fresh code on every deploy without a hard refresh.
 */

const isLocalhost =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname);

export function register() {
  if (
    typeof window === "undefined" ||
    !("serviceWorker" in navigator) ||
    isLocalhost
  ) {
    return;
  }

  window.addEventListener("load", () => {
    const swUrl = "/service-worker.js";
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        // Listen for updates: when a new SW takes over, reload once.
        let refreshing = false;
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          if (refreshing) return;
          refreshing = true;
          window.location.reload();
        });

        registration.addEventListener("updatefound", () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (
              installing.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              // New version available — apply immediately.
              installing.postMessage({ type: "SKIP_WAITING" });
            }
          });
        });
      })
      .catch(() => {
        /* swallowed: SW failing should never break the app */
      });
  });
}

export function unregister() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.ready
    .then((reg) => reg.unregister())
    .catch(() => null);
}
